import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstword'
})
export class onlyFirstWordPipe implements PipeTransform {

  transform(name:String): any {
  return name.split(" ")[0]


  }

}
